var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDnd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 19C5 19.5523 5.44772 20 6 20L19 20C19.5523 20 20 19.5523 20 19C20 18.4477 19.5523 18 19 18L6 18C5.44772 18 5 18.4477 5 19Z",
    fill: "#AABBC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12C5 12.5523 5.44772 13 6 13L19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11L6 11C5.44772 11 5 11.4477 5 12Z",
    fill: "#AABBC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5C5 5.55228 5.44772 6 6 6L19 6C19.5523 6 20 5.55228 20 5C20 4.44771 19.5523 4 19 4L6 4C5.44772 4 5 4.44772 5 5Z",
    fill: "#AABBC7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDnd);
export default __webpack_public_path__ + "static/media/Dnd.bd7eb1727400502be83e72c50c51e0dc.svg";
export { ForwardRef as ReactComponent };